<template>
  <div class="payment_password">
    <div class="payment_password_content">
      <div>
        <label><i>*</i>原始密码：</label>
        <input type="password" title="原始密码" maxlength="20" v-model.trim="oldPwd">
      </div>
      <div>
        <label><i>*</i>新密码：</label>
        <input type="password" title="新密码" maxlength="20" v-model.trim="newPwd">
      </div>
      <div>
        <label><i>*</i>确认密码：</label>
        <input type="password" title="确认密码" maxlength="20" v-model.trim="confirmPwd">
      </div>

      <div class="payment_password_btn">
        <button class="btn_normal ml150" @click="editPayPwd()">确定</button>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'payment-password',
    components: {MsgDialog, LoadingDialog},
    data() {
      return {
        oldPwd: null, // 旧密码
        newPwd: null, // 新密码
        confirmPwd: null, // 确认密码
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容' // 信息框内容
      }
    },
    methods: {
      // 修改分销商的支付密码
      editPayPwd() {
        if (!this.oldPwd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入原始密码';
          return;
        } else if (!this.newPwd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入新密码';
          return;
        } else if (!this.confirmPwd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入确认密码';
          return;
        } else if (this.newPwd !== this.confirmPwd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '输入的新密码与确认密码不一致';
          return;
        } else if (this.oldPwd === this.newPwd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '输入的新密码不能与原始密码相同';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OldPwd: this.oldPwd,
          NewPwd: this.newPwd
        };
        this.$axios.post(this.Global.editPayPwd, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '修改成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {

    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";

  .payment_password {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: $cfff;
    overflow-y: auto;

    .payment_password_content {
      padding-top: 30px;

      &>div {
        margin: 0 0 20px 40px;
        i {
          color: red;
        }

        label {
          display: inline-block;
          width: 100px;
          text-align: right;
        }

        input {
          width: 269px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/payment-password.vue